import { EnterpriseModel, ReceiptModel, TYPE_SEARCH, UserModel } from 'shared';
import { UUID } from 'symbols';

export interface CompanyMetaModel {
  egrpou: string;
  name: string;
  name_short: string;
  address: string;
  director: string;
  director_gen: string;
  kved: string;
  kved_number: string;
  inn: string;
  inn_date: string; // ISO-8601 date string
  last_update: string; // ISO-8601 date string
}

export interface InvoiceModel {
  id: string;
  createdAt: string; // ISO-8601 datetime string
  docNumber: number;
  date?: string; // ISO-8601 date string
  payer?: string;
  phone?: string;
  inPerson?: string;
  position?: string;
  bankCode?: string;
  bankName?: string;
  spr?: string;
  iban?: string;
  taxationSystem?: string;
  basisOf?: BasisOf;
  enterpriseId?: string;
  enterprise?: EnterpriseModel;
  waybillId?: string;
  waybill?: WayBillModel,
  acceptanceCertificateId?: string;
  acceptanceCertificate?: AcceptanceCertificateModel;
  serviceAgreementId?: string;
  serviceAgreement?: ServiceAgreementModel;
  purchaseAgreementId?: string;
  purchaseAgreement?: PurchaseAgreementModel;
  receipts: ReceiptModel[];

  comment?: string;
  isChanged?: boolean;
  isNew?: boolean;
  updater?: UserModel
  version?: number;
}

export enum BasisOf {
  CERTIFICATE = 'CERTIFICATE', // Свідоцтво про державну реєстрацію
  REGULATIONS = 'REGULATIONS', // Статут
  POSITION = 'POSITION', // Положення
}

export const BASIS_OF_RELATIONS_NAMES = {
  [BasisOf.CERTIFICATE]: 'Свідоцтво про державну реєстрацію',
  [BasisOf.REGULATIONS]: 'Статут',
  [BasisOf.POSITION]: 'Положення'
};

export enum TaxisSystemEnum {
  NON_PROFIT = 'NON_PROFIT',
  GENERAL = 'GENERAL',
  GENERAL_VAT = 'GENERAL_VAT',
  GROUP_1 = 'GROUP_1',
  GROUP_2 = 'GROUP_2',
  GROUP_3 = 'GROUP_3',
  GROUP_4 = 'GROUP_4',
  GROUP_2_VAT = 'GROUP_2_VAT',
  GROUP_3_VAT = 'GROUP_3_VAT',
  GROUP_4_VAT = 'GROUP_4_VAT',
}


export const TAXIS_SYSTEM_RELATIONS_NAMES = {
  [TaxisSystemEnum.NON_PROFIT]: 'Не прибуткова організація',
  [TaxisSystemEnum.GENERAL]: 'Загальна система оподаткування з ПДВ',
  [TaxisSystemEnum.GENERAL_VAT]: 'Загальна система оподаткування без ПДВ',
  [TaxisSystemEnum.GROUP_1]: '1 Група без ПДВ',
  [TaxisSystemEnum.GROUP_2]: '2 Група без ПДВ',
  [TaxisSystemEnum.GROUP_3]: '3 Група без ПДВ',
  [TaxisSystemEnum.GROUP_4]: '4 Група без ПДВ',
  [TaxisSystemEnum.GROUP_2_VAT]: '2 Група з ПДВ',
  [TaxisSystemEnum.GROUP_3_VAT]: '3 Група з ПДВ',
  [TaxisSystemEnum.GROUP_4_VAT]: '4 Група з ПДВ'
};

export interface InvoiceFilterModel {
  searchText?: string;
  typeSearch?: TYPE_SEARCH;
}

export interface InvoiceModelExpectBackend extends InvoiceModel {
  id: UUID;
  version: number;
  isNew?: boolean;
}

export interface WayBillModel {
  id: string;
  createdAt: string;
  date: string;
  comment: string;
  invoice: InvoiceModel;
}


export interface AcceptanceCertificateModel {
  id: string;
  createdAt: string;
  date: string;
  comment: string;
  invoice: InvoiceModel;
}


export interface ServiceAgreementModel {
  id: string;
  createdAt: string;
  date: string;
  comment: string;
  invoice: InvoiceModel;
}


export interface PurchaseAgreementModel {
  id: string;
  createdAt: string;
  date: string;
  comment: string;
  invoice: InvoiceModel;
}


export enum TypeOfInvoice {
  /**
   * Рахунок
   * */
  INVOICE = 'INVOICE',

  /**
   * Видаткова накладна
   * */
  WAYBILL = 'WAYBILL',

  /**
   * Акт виконаних робіт
   * */
  ACCEPTANCE_CERTIFICATE = 'ACCEPTANCE_CERTIFICATE',

  /**
   * Договір про надання послуг
   * */
  SERVICE_AGREEMENT = 'SERVICE_AGREEMENT',

  /**
   * Договір купівлі - продажу
   * */
  PURCHASE_AGREEMENT = 'PURCHASE_AGREEMENT',
}

export const nameDocRelationType: { [key: string]: string } = {
  [TypeOfInvoice.INVOICE]: 'Рахунок',
  [TypeOfInvoice.WAYBILL]: 'Видаткова накладна',
  [TypeOfInvoice.ACCEPTANCE_CERTIFICATE]: 'Акт виконаних робіт',
  [TypeOfInvoice.SERVICE_AGREEMENT]: 'Договір про надання послуг',
  [TypeOfInvoice.PURCHASE_AGREEMENT]: 'Договір купівлі - продажу'
};


export const INVOICES_LOCAL_STORAGE_KEY = 'invoices_data';
